import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=11c554b8&scoped=true"
import script from "./ai.vue?vue&type=script&lang=js"
export * from "./ai.vue?vue&type=script&lang=js"
import style0 from "./ai.vue?vue&type=style&index=0&id=11c554b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c554b8",
  null
  
)

export default component.exports